import { ADMIN_USER_TYPE } from "./constants";

/** Read persisted user_type from browser storage (email → localStorage, admin → sessionStorage). */
export function getStoredUserType() {
  return (
    localStorage.getItem("user_type") || sessionStorage.getItem("user_type")
  );
}

export function isAdminUserType(userType) {
  return userType === ADMIN_USER_TYPE;
}

/** True when /me user_type or stored user_type indicates brand-dashboard admin. */
export function isAdminUser(user) {
  const storedUserType = getStoredUserType();
  return (
    user?.data?.user_type === ADMIN_USER_TYPE ||
    storedUserType === ADMIN_USER_TYPE
  );
}
